<ng-container *ngIf="viewModel$ | async as vm">
  <ng-container *ngIf="vm.boilerOn">
    <app-icon name="heating" class="has-text-netatmo has-spacing-left-xs text-24"></app-icon>
  </ng-container>
</ng-container>